module.exports = __webpack_public_path__ + "img/2.b54a26c.png";